import { isOnlyNumbers } from '../validators';
import phone from './phone';
import { MIN_PHONE_CHARS, MAX_SIZE_PHONE } from './shared/constants.js';

export default function phoneEmail(value) {
  const valueIsPhone = isOnlyNumbers(value);

  if (valueIsPhone && value.length > MIN_PHONE_CHARS) {
    const splittedString = value.substr(0, MAX_SIZE_PHONE);
    return phone(splittedString);
  }

  return value;
}
